import { Component, OnInit } from "@angular/core";
import { LoginService } from "./login.service";
import { AuthenticationService } from "../authentication.service";
import { AuthHeaderService } from "../authheader.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
// import { RegisterComponent } from '../register/register.component'
import { CompanyService } from "../../services/company.service";
import { KeycloakService } from "keycloak-angular";
import { GeneratePdfComponent } from "../shared/generate-pdf/generate-pdf.component";

@Component({
  selector: "app-dashboard",
  templateUrl: "login.component.html",
  providers: [
    LoginService,
    AuthenticationService,
    AuthHeaderService,
    ToastrService,
  ],
})
export class LoginComponent {
  public Email: string;
  public Password: string;
  public isLogin: boolean = false;
  username: any;
  userdetails: any;
  logindetails;
  constructor(
    private _loginsevice: LoginService,
    private authenticate: AuthenticationService,
    private authHeader: AuthHeaderService,
    private cmpservice: CompanyService,
    private router: Router,
    private _toaster: ToastrService,
    public route: ActivatedRoute,
    private readonly keycloak: KeycloakService,
    private _makePdfService: GeneratePdfComponent
  ) { }

  async ngOnInit() {

    var val_token = this.route.snapshot.paramMap.get("token");
    if (val_token != null) {
      this.cmpservice.onCompanyValidate(val_token).subscribe((data) => {
        this._toaster.info(
          "Email Validation Successful Please Login",
          "Success",
          { timeOut: 1000 }
        );
        // this.router.navigateByUrl("login");
      });
    }

    var token = localStorage.getItem("token");
    let isLoggedIn = await this.keycloak.isLoggedIn();
    console.log("LOGIN        "+ isLoggedIn);

    var ismobile = localStorage.getItem("isMobile");
    if (isLoggedIn) {
      token = await this.keycloak.getToken();
      await this.Login()
      // this.router.navigateByUrl("/dashboard/dashboard");
    }
    else if(ismobile){
       this.loginKeyclok();
     }
    // else{
    //   //  this.keycloak.logout()
    // }

    // if (localStorage.getItem("userId") != null) {
    // }
  }
  async Login() {
    console.log("In login Function")
    this.isLogin = true;
     (await this._loginsevice.Login()).subscribe(
      (data) => {
        this.isLogin = false;
        console.log(data);
        // if (data.status == "SUCCESS!") {
          localStorage.setItem("userId", data["result"][0]["_id"]);
          var usercmpdetails = data["result"][0]["company"];
          let defaultCompnayDtls = usercmpdetails.filter(x => x.default === true)[0];

          console.log(defaultCompnayDtls);

          localStorage.setItem("selectedCompany", defaultCompnayDtls["company"]._id);
          localStorage.setItem("role", JSON.stringify(defaultCompnayDtls["role"]));
          localStorage.setItem("selectedCompanyName", defaultCompnayDtls["company"]["name"]);
          localStorage.setItem("companyType", defaultCompnayDtls["company"]["companyType"]);
          localStorage.setItem("subscriptionType", defaultCompnayDtls["company"]["subscriptionType"]);
          if (data["result"][0]["fullname"] != undefined) {
            localStorage.setItem("loggedinUserFullName", data["result"][0]["fullname"]);
          }
          else{
            localStorage.setItem("loggedinUserFullName", "");
          }
          const companyType = defaultCompnayDtls["company"]["companyType"];
          this.authenticate.setLogin(data);
          this.cmpservice.getCompanyConfiguration().subscribe((data) => {
            console.log(data);
            let featuresList = data.result.features.filter(feature => feature.isActivated == true);
            localStorage.setItem("featuresList", JSON.stringify(featuresList));
            if(defaultCompnayDtls["company"]["companyType"] == 'Dump_Trucks'){
              this.router.navigateByUrl("job-dashboard/dashboard");
            }
            else{
              this.router.navigateByUrl("dashboard/dashboard");
            }
          })
          this._makePdfService.setPdfData(defaultCompnayDtls.company?.companyLogo?.fileName);
          // } else {
            //   this.isLogin = false;
        //   this._toaster.error("Invalid UserId and Password", "Failed", { timeOut: 1000 });
        // }
      },
      (error) => {
        this.isLogin = false;
        if (error._body.includes("verified")) {
          this._toaster.error(JSON.parse(error._body).error, "Failed", { timeOut: 1000 });
        } else {
          this._toaster.error("Invalid UserId and Password", "Failed", { timeOut: 1000 });
        }
      }
      );
  }
  Forgotpassword() {
    this.router.navigateByUrl("forgotPassword");
  }
  onregister() {
    this.router.navigateByUrl("register");
  }
  oncompanyregister() {
    this.router.navigateByUrl("companyregister");
  }
  loginKeyclok(){
    this.keycloak.login();
  }
}
